export default __webpack_public_path__ + "media/assets/images/left-bg-image-4ac38b59af1b62ff3b0e8b43fc90d642.png";